import { css } from 'react-emotion';
import { colors, heights, animationTransition } from '../../variables';

const leftItemBorderRules = {
  borderRadius: `.5rem 0 0 .5rem`
};
const rightItemBorderRules = {
  borderRadius: `0 .5rem .5rem 0`
};

export namespace styles {
  export const inputContainer = (inGroup: boolean = false) =>
    css({
      width: '100%',
      display: 'inline-flex',
      ' > button:last-child': rightItemBorderRules,
      ' > button:first-child': leftItemBorderRules,
      ' > input:first-child': {
        borderTopLeftRadius: '.5rem',
        borderBottomLeftRadius: '.5rem'
      },
      ' > input:last-child': {
        borderTopRightRadius: '.5rem',
        borderBottomRightRadius: '.5rem'
      },
      margin: !inGroup ? 0 : 0
    });
  export const input = (
    error: boolean = false,
    disabled: boolean = false,
    inGroup: boolean = false,
    groupFirst: boolean = false,
    groupLast: boolean = false,
    textArea: boolean,
    disableBorder = false
  ) =>
    css({
      height: !textArea ? heights.INPUT_HEIGHT : 'inherit',
      border: !inGroup ? '1px solid transparent' : 'none',
      borderColor: !inGroup ? (!error ? (!disableBorder ? colors.gray : undefined) : colors.bad) : undefined,
      backgroundColor: !disabled ? '#fff' : colors.gray,
      transition: animationTransition('border-color', 'background-color'),
      display: 'block',
      outline: 'none',
      padding: `1.3rem 1.6rem`, // !inGroup ? '.65rem 0 .65rem 1rem' : '.25rem 0 .25rem 0',
      // margin: !inGroup ? '8px 0' : '0',
      // marginRight: '-1rem',
      fontSize: '1.5rem',
      fontWeight: 300,
      lineHeight: '2.1rem',
      width: '100%',
      disabled,
      resize: 'none',
      boxSizing: 'border-box',
      cursor: !disabled ? 'cursor' : 'not-allowed',
      '::placeholder': {
        color: !disabled ? colors.gray : '#999'
      },
      ':focus': !inGroup
        ? {
            borderColor: !error ? colors.action : colors.bad,
            outline: 'none'
            // boxShadow: `0 0 0 1px ${!error ? colors.action : colors.bad}`
          }
        : undefined
    });

  export const textarea = (error: boolean = false, disabled: boolean = false) =>
    css({
      borderRadius: '5px',
      backgroundColor: disabled ? colors.neutral : '#ffffff',
      padding: '13px 15px',
      fontSize: 15,
      resize: 'none',
      width: '100%',
      transition: animationTransition('border-color'),
      border: '1px solid transparent',
      borderColor: error ? colors.bad : undefined,
      ':focus': {
        borderColor: !error ? '#5ba4e5' : undefined
      },
      color: '#333333',
      letterSpacing: '.2px',
      lineHeight: '24px'
    });

  export const groupBreak = css({
    borderBottom: '1px solid',
    borderColor: colors.light
  });
}
